import React from 'react';
import { AdminFormValues } from './Add';

interface AdminFormProps {
  form: AdminFormValues;
  setForm: React.Dispatch<React.SetStateAction<AdminFormValues>>;
  showPassword: boolean;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
  showPasswordConfirm: boolean;
  setShowPasswordConfirm: React.Dispatch<React.SetStateAction<boolean>>;
  sessionTypeOptions: { value: string; label: string }[];
  statusOptions: { value: string; label: string }[];
  isEdit?: boolean;
}

const AdminForm: React.FC<AdminFormProps> = ({
  form,
  setForm,
  showPassword,
  setShowPassword,
  showPasswordConfirm,
  setShowPasswordConfirm,
  sessionTypeOptions,
  statusOptions,
  isEdit = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  return (
    <form className="space-y-6">
      <div>
        <label className="block mb-1 text-sm text-gray-600">ログインID</label>
        <input
          type="text"
          name="loginId"
          className={`w-full px-2 py-1 border rounded${isEdit ? ' bg-gray-100' : ''}`}
          value={form.loginId}
          onChange={handleChange}
          readOnly={isEdit}
        />
      </div>
      <div>
        <label className="block mb-1 text-sm text-gray-600">パスワード</label>
        <div className="relative">
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            className="w-full px-2 py-1 pr-10 border rounded"
            value={form.password}
            onChange={handleChange}
            autoComplete="new-password"
            placeholder={isEdit ? '変更する場合のみ入力' : ''}
          />
          <button
            type="button"
            className="absolute inset-y-0 flex items-center text-xs text-gray-500 right-2"
            tabIndex={-1}
            onClick={() => setShowPassword(v => !v)}
          >
            {showPassword ? '非表示' : '表示'}
          </button>
        </div>
      </div>
      <div>
        <label className="block mb-1 text-sm text-gray-600">パスワード確認</label>
        <div className="relative">
          <input
            type={showPasswordConfirm ? 'text' : 'password'}
            name="passwordConfirm"
            className="w-full px-2 py-1 pr-10 border rounded"
            value={form.passwordConfirm}
            onChange={handleChange}
            autoComplete="new-password"
            placeholder={isEdit ? '変更する場合のみ入力' : ''}
          />
          <button
            type="button"
            className="absolute inset-y-0 flex items-center text-xs text-gray-500 right-2"
            tabIndex={-1}
            onClick={() => setShowPasswordConfirm(v => !v)}
          >
            {showPasswordConfirm ? '非表示' : '表示'}
          </button>
        </div>
      </div>
      <div>
        <label className="block mb-1 text-sm text-gray-600">会社名</label>
        <input type="text" name="company" className="w-full px-2 py-1 border rounded" value={form.company} onChange={handleChange} />
      </div>
      <div>
        <label className="block mb-1 text-sm text-gray-600">担当者名</label>
        <input type="text" name="name" className="w-full px-2 py-1 border rounded" value={form.name} onChange={handleChange} />
      </div>
      <div>
        <label className="block mb-1 text-sm text-gray-600">メールアドレス</label>
        <input type="email" name="email" className="w-full px-2 py-1 border rounded" value={form.email} onChange={handleChange} />
      </div>
      <div>
        <label className="block mb-1 text-sm text-gray-600">セッションタイプ</label>
        <select name="sessionType" className="w-full px-2 py-1 border rounded" value={form.sessionType} onChange={handleChange}>
          {sessionTypeOptions.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="block mb-1 text-sm text-gray-600">ステータス</label>
        <select name="status" className="w-full px-2 py-1 border rounded" value={form.status} onChange={handleChange}>
          {statusOptions.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
    </form>
  );
};

export default AdminForm;
